export default {
    methods: {
        checkLocale(local) {
            try {
                var tmpTranslations = require("../lang/" + local);
            } catch (err) {
                this.$router.push({ params: { lang: "ru" } });
            }
            return tmpTranslations;
        }
    }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/helper.js